module.exports = __webpack_public_path__ + "img/WE_d3.9b44247c.png";